module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-welcome-board-3bc074fc3321d0f17e72121f4e16c051.jpg";